import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NetworkService } from '../../service/network.service';
import { GenericAkitaHTTPService, HttpOptions } from '../../service/generic-akita-http.service';
import { EmergencyUnit } from '../../model/unit';

@Injectable({
  providedIn: 'root'
})
export class AkitaUnitHttpService extends GenericAkitaHTTPService<EmergencyUnit> {

  constructor(http: HttpClient, networkService: NetworkService) {
    const options: HttpOptions = {
      params: {
        type: 'EmergencyUnit',
        options: 'keyValues',
        attrs: '*,dateModified',
        limit: '50'
      }
    };
    super(http, networkService, '/v2/entities/', 'EmergencyUnit', options);
  }
  
}
